import { useRouter } from "next/router";
import { useMemo } from "react";
import { Theme, useMediaQuery } from "@mui/material";

export const isMobileDevice = (userAgent:string) => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Chrome Mobile/i.test(userAgent);
}

export const useDeviceType = () => {
    const {query } = useRouter();
    const tempIsM = useMediaQuery((theme:Theme)=>theme.breakpoints.down('sm'));
    const isMobile = useMemo(()=>query?.viewport==='mobile' || tempIsM,[query]);
    return {
        isMobile:isMobile,
        isDesktop:!isMobile
    }
};
